export default __webpack_public_path__ + "static/media/Summary.e5a9a39b.webp";